<template>
  <v-container>
    <v-layout text-xs-center wrap>
      <v-flex xs12>
        <v-img :src="require('@/assets/logo.png')" class="my-3" contain></v-img>
      </v-flex>
      <v-flex xs12 mb-4>
        <h1 class="display-2 font-weight-bold mb-3">Welcome!</h1>
        <p class="subheading font-weight-regular">Please use the bottom navigation to start!</p>
        <p class="subheading font-weight-regular">OR</p>
        <p class="subheading font-weight-regular">View your tasks below</p>

        <v-flex xs12>
          <v-list class="elevation-5 mb-3 pa-0" dense>
            <v-list-group v-model="expand">
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <h3>Tasks</h3>
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <div v-if="UserTasks.length == 0">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>NO TASKS!</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
              <v-list-tile v-for="task in UserTasks" :key="task.ID" @click="viewTask(task)" v-else>
                <v-list-tile-content>
                  <v-list-tile-title>{{ task.Name }}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-chip v-if="task.Complete" outline color="green" text-color="black" selected>
                    <v-avatar class="green">C</v-avatar>Complete
                  </v-chip>
                  <v-chip v-else outline color="orange" text-color="black" selected>
                    <v-avatar class="orange">P</v-avatar>Pending
                  </v-chip>
                </v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </v-flex>

        <!-- <p class="subheading font-weight-regular">Your current location is: {{location}}</p> -->
      </v-flex>
    </v-layout>
    <br>
    <v-layout row wrap justify-center v-if="latlon != null">
      <!-- <input @change="onImageChange" style="display: none" ref="fileInput" type="file" accept="image/*">
      <img style="width: 100%;" @click="openFileDialog" :aspect-ratio="16/9" ref="" :src="displayImage">-->
      <!-- <v-btn color="primary" @click="openCamera">Camera</v-btn> -->
    </v-layout>
    <!-- <input @change="onImageChange" style="display: none" ref="fileInput" type="file" accept="image/*">
    <img style="width: 100%;" @click="openFileDialog" :aspect-ratio="16/9" ref="" :src="displayImage">-->

    <v-dialog v-model="taskDialog" width="500">
      <v-card class="pa-1">
        <v-flex xs12>
          <v-form>
            <v-layout row align-center>
              <v-subheader>
                <v-icon class="mr-2">mdi-calendar</v-icon>
                {{taskDialogData.Name}}
              </v-subheader>
              <v-spacer></v-spacer>
              <v-btn small color="success" round ripple @click="completeTask">complete!</v-btn>
            </v-layout>
            <v-layout justify-end>
              <v-btn small color="secondary" v-if="taskDialogData.FilePath != ''" round ripple
                @click="showImage(taskDialogData)">Show image</v-btn>
            </v-layout>
          </v-form>
        </v-flex>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPhoto" max-width="500px">
      <v-flex xs12>
        <v-card>
          <v-toolbar dense color="secondary" dark>
            <v-toolbar-title>Meeting Task Photo</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-layout fill-height>
            <v-img v-if="photoUrl != null" :src="photoUrl"></v-img>
          </v-layout>
        </v-card>
      </v-flex>
    </v-dialog>
  </v-container>
</template>

<script>
  import JWT from "jsonwebtoken";

  export default {
    data: () => ({
      expand: true,
      photoUrl: null,
      taskDialog: false,
      taskDialogData: {
        Name: null
      },
      location: null,
      googleMapSrc: "",
      latlon: null,
      UserTasks: [],
      photo: "",
      showPhoto: false,
    }),
    mounted() {
      this.GetLocation();
      this.GetUserTasks();
    },
    methods: {
      GetUserTasks() {
        let self = this;
        let sessionData = self.$store.getters.getUserSessionData;
        let tokenDecoded = JWT.decode(sessionData.AccessToken);
        let userID = tokenDecoded.USER_ID;

        self.get(`MeetingTask/SystemUserID?systemUserID=${userID}`).then(r => {
          if (r.data == null) {
            return;
          }
          self.UserTasks = r.data;
        });
      },
      GetLocation() {
        let self = this;
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            self.showPosition,
            self.locationError
          );
        } else {
          self.location = "Geolocation is not supported by this browser.";
        }
      },
      showPosition(position) {
        let self = this;
        self.location =
          "Latitude: " +
          position.coords.latitude +
          ", Longitude: " +
          position.coords.longitude;
        self.showInMap(position);
      },
      mapsSelector() {
        let self = this;
        if (
          /* if we're on iOS, open in Apple Maps */
          navigator.platform.indexOf(
            "iPhone"
          ) != -1 ||
          navigator.platform.indexOf("iPad") != -1 ||
          navigator.platform.indexOf("iPod") != -1
        )
          window.open(`maps://maps.google.com/maps?daddr=${self.latlon}&amp;ll=`);
        /* else use Google */
        else
          window.open(
            `https://maps.google.com/maps?daddr=${self.latlon}&amp;ll=`
          );
      },
      locationError(error) {
        let self = this;
        switch (error.code) {
          case error.PERMISSION_DENIED:
            self.location = "User denied the request for Geolocation.";
            break;
          case error.POSITION_UNAVAILABLE:
            self.location = "Location information is unavailable.";
            break;
          case error.TIMEOUT:
            self.location = "The request to get user location timed out.";
            break;
          case error.UNKNOWN_ERROR:
            self.location = "An unknown error occurred.";
            break;
        }
      },
      showInMap(pos) {
        let self = this;
        self.latlon = pos.coords.latitude + "," + pos.coords.longitude;
        var img_url = `https://maps.googleapis.com/maps/api/staticmap?center="${
        self.latlon
      }" &zoom=14&size=400x300&sensor=false&&markers=color:blue%7Clabel:%7C${
        self.latlon
      }&key=AIzaSyC5tXRKX6Wz8f2RrAzFeifrzkNB0EIYL-A`;
        self.googleMapSrc = img_url;
      },
      viewTask(task) {
        let self = this;
        self.taskDialogData = task;
        self.taskDialog = true;
      },
      completeTask() {
        let self = this;
        let id = self.taskDialogData.ID;
        self.post(`MeetingTask/CompleteTask?id=${id}`).then(r => {
          if (r.data) {
            self.GetUserTasks();
            self.taskDialog = false;
          }
        });
      },
      openFileDialog() {
        let self = this;
        self.$refs.fileInput.value = null;
        self.$refs.fileInput.click();
      },
      onImageChange(e) {
        let self = this;

        const files = e.target.files;
        let file = files[0];
        self.blobToDataUrl(file, url => {
          self.displayImage = url;
          // self.blobToArrayBuffer(file, result => {
          //   self.profile.image = Array.from(new Uint8Array(result));
          // })
        });
      },
      blobToArrayBuffer(blob, callback) {
        var a = new FileReader();
        a.onload = function () {
          callback(a.result);
        };
        a.readAsArrayBuffer(blob);
      },
      blobToDataUrl(blob, callback) {
        var a = new FileReader();
        a.onload = function () {
          callback(a.result);
        };
        a.readAsDataURL(blob);
      },
      showImage(item) {
        let self = this;
        self.showPhoto = true;
        console.log("show image", item)

        let address = self.$Config.ServerAddress;
        //console.log("address", address);
        if (item.FilePath != '') {
          self.photoUrl = `${address}Photo/Stream/Meeting?id=${item.ID}`;

        }
      },
    }
  };
</script>

<style>
</style>